import { verifyRestorePassword } from './verifyRestorePassword'
import { uploadProfilePicture, deleteProfilePicture } from './profilePicture'
import { getUserByConfirmId } from './getUserByConfirmId'
import { getRoles } from './getRoles'
import { getExistUser } from './getExistUser'
import { getIntegrationData } from './getIntegrationData'
import { getRolesLeads } from 'BFF/BFF_user/getRolesLeads'
import { getUsersReport } from './getUsersReport'
import { putCustomFilters } from './putCustomFilters'
import { getCustomFilters } from './getCustomFilters'
import { updateUnreadPushNotifications } from './updateUnreadPushNotifications'

export const User = {
  verifyRestorePassword,
  uploadProfilePicture,
  deleteProfilePicture,
  getUserByConfirmId,
  getRoles,
  getExistUser,
  getIntegrationData,
  getRolesLeads,
  getUsersReport,
  putCustomFilters,
  getCustomFilters,
  updateUnreadPushNotifications
}
